import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

const planType = planTypes.ZOOM_ROOMS;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.planform.title.zoomroom'),
      logo: getPlanLogo(planTypes.ZOOM_ROOMS),
      description: this.$t('billing.zr.desc'),
    };
  },
};
